var _circle, _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconVertificationConfirm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_167_5722",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 80,
    height: 80
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 39.4445,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_167_5722)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.993744,
    y: 2.7865,
    width: 111.162,
    height: 101.599,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.304 57.9963C53.4358 57.9963 56.4973 57.0674 59.1012 55.3271C61.705 53.5868 63.7341 51.1133 64.9319 48.2195C66.1297 45.3258 66.4422 42.1417 65.8301 39.0703C65.2179 35.9988 63.7085 33.1779 61.4928 30.9645C59.2771 28.7511 56.4547 27.2446 53.3826 26.6355C50.3105 26.0265 47.1268 26.3424 44.2342 27.5431C41.3417 28.7438 38.8703 30.7755 37.1326 33.3812C35.395 35.9868 34.4692 39.0492 34.4724 42.1811C34.4724 44.2593 34.882 46.3172 35.6779 48.2371C36.4737 50.1569 37.6401 51.9011 39.1104 53.3699C40.5807 54.8387 42.3261 56.0033 44.2467 56.7972C46.1674 57.591 48.2257 57.9985 50.304 57.9963Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.304 57.9963C53.4358 57.9963 56.4973 57.0674 59.1012 55.3271C61.705 53.5868 63.7341 51.1133 64.9319 48.2195C66.1297 45.3258 66.4422 42.1417 65.8301 39.0703C65.2179 35.9988 63.7085 33.1779 61.4928 30.9645C59.2771 28.7511 56.4547 27.2446 53.3826 26.6355C50.3105 26.0265 47.1268 26.3424 44.2342 27.5431C41.3417 28.7438 38.8703 30.7755 37.1326 33.3812C35.395 35.9868 34.4692 39.0492 34.4724 42.1811C34.4724 44.2593 34.882 46.3172 35.6779 48.2371C36.4737 50.1569 37.6401 51.9011 39.1104 53.3699C40.5807 54.8387 42.3261 56.0033 44.2467 56.7972C46.1674 57.591 48.2257 57.9985 50.304 57.9963Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2581 93.8692C86.2581 74.0229 70.1665 63.2789 50.304 63.2789C30.4414 63.2789 14.3173 74.0229 14.3173 93.8692C14.3173 93.8692 11.0314 102.707 50.2877 102.707C89.544 102.707 86.2581 93.8692 86.2581 93.8692Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2581 93.8692C86.2581 74.0229 70.1665 63.2789 50.304 63.2789C30.4414 63.2789 14.3173 74.0229 14.3173 93.8692C14.3173 93.8692 11.0314 102.707 50.2877 102.707C89.544 102.707 86.2581 93.8692 86.2581 93.8692Z",
    fill: "#C9C9C9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.9999 98C89.9411 98 98 89.9411 98 80C98 70.0589 89.9411 62 79.9999 62C70.0588 62 62 70.0589 62 80C62 89.9411 70.0588 98 79.9999 98Z",
    fill: "#56C968"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.4253 74.5746C89.1915 75.3408 89.1915 76.5829 88.4253 77.3491L78.3011 87.4733L71.5746 80.7468C70.8084 79.9807 70.8084 78.7385 71.5746 77.9723C72.3407 77.2062 73.5829 77.2062 74.349 77.9723L78.3011 81.9244L85.6509 74.5746C86.417 73.8085 87.6592 73.8085 88.4253 74.5746Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVertificationConfirm);
export default __webpack_public_path__ + "static/media/icon-vertification-confirm.98c3b7f55c91576a0cee7825069ff0ce.svg";
export { ForwardRef as ReactComponent };